import { useState, useEffect } from 'react';

function useMapCmsToScreenSize(windowSize, displayOn) {
    const [mapScreenSize, setMapScreenSize] = useState(false);

    useEffect(() => {
        let windowArray: string[] = [];

        if (windowSize.isLargeScreen) {
            windowArray.push('desktop');
        }

        if (windowSize.isMediumScreen) {
            windowArray.push('tablet');
        }

        if (windowSize.isSmallScreen) {
            windowArray.push('mobile');
        }

        const displayMapSet = new Set(windowArray);
        const intersection = displayOn.filter(item => displayMapSet.has(item));

        setMapScreenSize(intersection.length > 0);
    }, [windowSize, displayOn]);

    return mapScreenSize;
}

export default useMapCmsToScreenSize;
